// 側邊欄邊緣：拖寬度的把手 + 摺疊鈕（所有頁面共用，狀態在 lib/usePanelWidth）。
// 放在放這一欄的格線裡（那個格線要 position: relative），用 grid-column（起點 / 終點都寫，終點不寫會延伸到整個格線的邊）指定貼在哪一欄的邊上；
// 絕對定位，不佔格子，不影響其他東西的排列。窄螢幕（panel.active = false）整個不出現。
import { PanelLeftClose, PanelLeftOpen, PanelRightClose, PanelRightOpen } from 'lucide-react';
import type { PanelState } from '../lib/usePanelWidth';
import Icon from './Icon';
import './PanelEdge.css';

interface Props {
  panel: PanelState;
  /** 這一欄的名字，用在提示文字：「打開歌單」「收起右邊面板」 */
  label: string;
  /** 這一欄在格線的第幾欄（從 1 算） */
  column: number;
}

export default function PanelEdge({ panel, label, column }: Props) {
  if (!panel.active) return null;
  const left = panel.side === 'left';
  const FoldIcon = panel.collapsed ? (left ? PanelLeftOpen : PanelRightOpen) : (left ? PanelLeftClose : PanelRightClose);
  const foldTitle = panel.collapsed ? `打開${label}` : `收起${label}`;
  return (
    <div
      className={`panel-edge panel-edge--${panel.side}${panel.collapsed ? ' is-collapsed' : ''}`}
      style={{ gridColumn: `${column} / ${column + 1}` }}
    >
      {!panel.collapsed && (
        <div
          className="panel-edge__grip"
          role="separator"
          aria-orientation="vertical"
          aria-label={`拖曳調整${label}寬度`}
          title="拖曳調整寬度（雙擊回到預設）"
          tabIndex={0}
          {...panel.handleProps}
        />
      )}
      <button
        type="button"
        className="panel-edge__fold"
        title={foldTitle}
        aria-label={foldTitle}
        aria-expanded={!panel.collapsed}
        onClick={panel.toggle}
      >
        <Icon icon={FoldIcon} size="sm" />
      </button>
    </div>
  );
}
